import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'

import appleTouchIcon from '../images/apple-touch-icon.png'
import favicon32 from '../images/favicon-32x32.png'
import favicon16 from '../images/favicon-16x16.png'
import safariTab from '../images/safari-pinned-tab.svg'
import ogImage from '../images/hero-bindle.jpg'

import Footer from '../components/global/Footer'
import Header from '../components/global/Header'
import GlobalCss from '../components/global/GlobalCss'
import PageTransition from '../components/animations/PageTransition'
import DisplayContext from '../contexts/DisplayContext'

const TemplateWrapper = ({ children, footerData }) => {

  return (
    <>
      <Helmet>
        <html lang="en" />

        <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
        <link rel="icon" type="image/png" href={favicon32} sizes="32x32" />
        <link rel="icon" type="image/png" href={favicon16} sizes="16x16" />

        <link rel="mask-icon" href={safariTab} color="#ff4400" />
        <meta name="theme-color" content="#FF81F2" />
        <meta property="og:image" content={ogImage} />
        <meta property="og:type" content="business.business" />

      </Helmet>
      <DisplayContext.Provider value="live">
        <GlobalCss />
        <Header />
        <PageTransition>
          {children}
          <Footer data={footerData} />
        </PageTransition>
      </DisplayContext.Provider>
    </>
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  footerData: PropTypes.object.isRequired,
}

export default TemplateWrapper
